/**
 * global-error-handler.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { ErrorHandler, Injectable, Optional } from "@angular/core";

import { RingBuffer } from "../support/utilities/ring-buffer";

export class GlobalErrorHandler implements ErrorHandler
{
    public recentErrors : RingBuffer<any> = new RingBuffer(5);
    public lastError : any = null;

    public rethrow : boolean;
    constructor (@Optional() rethrow : boolean = false)
    {
        // Since this class is subject to injection, we delimit the rethrow arg
        // as optional so that the injector doesn't get confused looking for a
        // the token `boolean`.
        this.rethrow = rethrow;
    }

    public handleError (error : any) : void
    {
        // Keep track of recent errors for debugging & issue reporting purposes
        this.recentErrors.add(error);
        this.lastError = error;

        error = this.unwrap(error);
        console.error(error);
        if (error.stack)
        {
            console.error(error.stack);
        }

        // This is modeled after the built-in Angular ErrorHandler, but at the
        // moment we aren't manually constructing it anywhere, so in practice
        // this code branch isn't ever used.
        if (this.rethrow)
        {
            throw error;
        }
    }

    private unwrap (error : any) : any
    {
        while (error.originalError && typeof error.originalError === "object")
        {
            error = error.originalError;
        }
        return error;
    }
}

export const CUSTOM_ERROR_HANDLER : any = {
    provide : ErrorHandler,
    useClass: GlobalErrorHandler
};



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/debug/global-error-handler.ts